import { render, staticRenderFns } from "./TravelComponent.vue?vue&type=template&id=1d9873d6&scoped=true&"
import script from "./TravelComponent.vue?vue&type=script&lang=js&"
export * from "./TravelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9873d6",
  null
  
)

export default component.exports